// import Logout from "../pages/mine/setting/logout";

export default {
//-----config----------------------------------------------------------------
    'host': '',

//---h5 相关--------------------------------------------------------

    //-custom--------------------
    'mine': '/mine',     //我的
    'auth': '/auth',     //认证页面
    //--------------------------------------

    // 'logout': '/Logout',   //设置页
    'errorUrl' : '/wuxadroNotrufem', //'/jointLogonFail',     //准入失败页面
    'loanDetailUrl' : '/ostofykizAbrefyz', // '/loanDetailsV3',     //借款详情页
    'orderUrl' :  '/wolegufoVukysostuw', //'/loanDetailsV3',     //订单详情页面
    'confirmUrl' : '/styremuxeUvogybr', //'/confirmOfLoanV3',     //借款详情页
    'confirmNewUrl' : '/xuxelulequGycequah', //'/confirmUrl',     //后置确认详情页
    'confirmOfPeriod' : '/rehedryIrawymuhy', //'/confirmOfLoanV3',     //借款详情页
    'repayUrl' :  '/spuxathHekedraphi', //'/repaymentOfPeriod',     //还款页
    'customerService' :  '/dedrasaWydrylox', //客服页面
    'loanAgreement' :  '/thixythKafulug', //'/loanDetailsV3',     //借款协议
    'aboutUs' :  '/Crunedywyp', //'/loanDetailsV3',     //关于我们
    'privacyPolicy' :  '/trykastuspJyrybrade', //'/privacyPolicy',      //隐私协议
    'repayDelayUrl' : '/quyzyrathuEsestedel',  //展期
    'complaint' : '/lowothafZaquotru',  //客服案件投诉入口
    'bindBank' : '/chuspycaYtrashan',  //绑卡页面
    'orderDetail' : '/many_years',    //订单详情 授信模式用
    // 'bindCardUrl':'',


    'setting' : 'gruphitrid',   //设置页
    'logout' : 'logout',        //注销账号页
    'main' : 'not',     //首页
    'login' : 'celebrating',     //登录
    'order' : 'aa',          //订单
    'productDetail' : 'adrahoce',    //产品详情
    
    'landingPage': '/ddd',    //落地页
    'faceDetection': '/FaceDetection',    //人脸识别
    //--------值映射-认证项------------------------------

    'banner': "usimerylia",
    'largeCard': "usimerylib",
    'smallCard': "usimerylic",
    'productList': "usimerylid",

    "public": "mivixytha", // ocr认证
    "personal": "mivixythb", // 个人信息
    "job": "mivixythc", // 个人信息
    "ext": "mivixythd", // 紧急联系人
    "bank": "mivixythe", // 绑卡

    "enum": "phedroqua",
    "txt": "phedroqub",
    "citySelect": "phedroquc",
    "day": "sd",

}
